var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 3.75C5.625 3.12868 6.12868 2.625 6.75 2.625H11.25C12.6424 2.625 13.9777 3.17813 14.9623 4.16269C15.9469 5.14726 16.5 6.48261 16.5 7.875C16.5 9.26737 15.9469 10.6028 14.9623 11.5873C13.9777 12.5719 12.6424 13.125 11.25 13.125H7.875V18C7.875 18.6213 7.37132 19.125 6.75 19.125C6.12868 19.125 5.625 18.6213 5.625 18V3.75ZM7.875 10.875H11.25C12.0457 10.875 12.8087 10.5589 13.3713 9.9963C13.9339 9.43372 14.25 8.67067 14.25 7.875C14.25 7.07935 13.9339 6.31629 13.3713 5.75368C12.8087 5.19107 12.0457 4.875 11.25 4.875H7.875V10.875Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70446 11.2045C10.1438 10.7652 10.8562 10.7652 11.2955 11.2045L19.5455 19.4545C19.9848 19.8938 19.9848 20.6062 19.5455 21.0455C19.1062 21.4848 18.3938 21.4848 17.9545 21.0455L9.70446 12.7955C9.26518 12.3562 9.26518 11.6438 9.70446 11.2045Z",
    fill: "#714FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5455 14.2045C19.9848 14.6438 19.9848 15.3562 19.5455 15.7955L14.2955 21.0455C13.8562 21.4848 13.1438 21.4848 12.7045 21.0455C12.2652 20.6062 12.2652 19.8938 12.7045 19.4545L17.9545 14.2045C18.3938 13.7652 19.1062 13.7652 19.5455 14.2045Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderLogo);
export default __webpack_public_path__ + "static/media/order-logo.3aec3e6807b88c47587118d479a4487c.svg";
export { ForwardRef as ReactComponent };